import { initialState ,Action, reducer} from './../Action';
import { request } from "./request";
import { AnyType, MethodEmun } from "@/types";
 
import { sha256 } from "js-sha256";

//获取所有组播号码规则 access_token  
export const getAllBroadcastNumberRules: () => Promise<AnyType> = () =>{
    return request({
      url: "/number/list",
      method: MethodEmun.post,
      headers: {
        'Authorization': 'Bearer '+initialState.accessToken,
        'Content-Type': 'application/json'
      },
    });
  }